import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import axios from 'axios'
import { inject } from 'mobx-react'
import moment from 'moment'
import 'moment/locale/sq'
import pubsub from 'pubsub-js'
import React from 'react'
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap'

@inject('userStore')
class UserNotes extends React.Component {
  constructor() {
    super()
    this.state = {
      loading: true,
      error: null,
      dropdownOpen: {},
      usernotes: [],
      newNote: '',
      open: false
    }
  }

  handleClickOpen = () => {
    this.setState({
      open: true
    })
  }

  handleClose = () => {
    this.setState({
      open: false
    })
  }

  async componentDidMount() {
    try {
      const response = await axios.get(`usernotes/${this.props.userId}`)
      if (response.data.success) {
        this.setState({
          usernotes: response.data.data,
          loading: false
        })
      } else {
        this.setState({
          error: response.data.message,
          loading: false
        })
      }
    } catch (e) {
      this.setState({
        loading: false
      })
    }
  }

  onChangeNote = (e) => {
    this.setState({
      newNote: e.target.value
    })
  }

  dropdownToggle = (index) => {
    this.setState({
      dropdownOpen: { [index]: !this.state.dropdownOpen[index] }
    })
  }

  deleteNote = async (noteId) => {
    try {
      const response = await axios.post(`usernotes/${this.props.userId}/${noteId}`)
      if (response.data.success) {
        this.setState({
          loading: false,
          usernotes: this.state.usernotes.filter((note) => {
            return note._id != noteId
          })
        })
      } else {
        this.setState({
          error: response.data.message,
          loading: false
        })
      }
    } catch (e) {
      this.setState({
        loading: false
      })
    }
  }
  cancelLastTransfer = async () => {
    try {
      const res = await axios.post(`/users/cancel-last-transfer/${this.props.userId}`)

      if (res.data.success) {
        this.props.onAnuloTransferClick()
      } else {
        this.setState({
          error: res.data.message,
          loading: false
        })
      }
    } catch (e) {
      this.setState({
        loading: false
      })
    }
  }

  saveNote = async (e) => {
    e.preventDefault()
    if (this.state.newNote != '') {
      this.setState({
        loading: true
      })
      try {
        const response = await axios.post(`usernotes/${this.props.userId}`, {
          note: this.state.newNote
        })
        if (response.data.success) {
          this.setState({
            loading: false,
            newNote: '',
            usernotes: [...this.state.usernotes, response.data.data]
          })
        } else {
          this.setState({
            loading: false
          })
          pubsub.publish('showNotification', {
            message: response.data.message,
            type: 'error'
          })
        }
      } catch (e) {
        pubsub.publish('showNotification', {
          message: 'Gabim gjatë ruajtjes së të dhënave',
          type: 'error'
        })
      }
    }
  }

  render() {
    return (
      <div className={`${this.state.loading && 'whirl standard'}`}>
        <Dialog open={this.state.open} keepMounted onClose={this.handleClose} aria-describedby='alert-dialog-slide-description'>
          <DialogTitle>{'A jeni i sigurtë që dëshironi ta anuloni transferin e fundit?'}</DialogTitle>
          <DialogContent></DialogContent>
          <DialogActions sx={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
            <Button onClick={this.handleClose} variant='contained' sx={{ fontSize: '12px' }}>
              Jo, kthehu prapa
            </Button>
            <Button
              onClick={() => {
                this.cancelLastTransfer()
                this.handleClose()
                this.props.onAnuloTransferClick()
              }}
              variant='contained'
              color='error'
              sx={{ fontSize: '12px' }}
            >
              Po anuloje!
            </Button>
          </DialogActions>
        </Dialog>

        {this.state.error && <p className='text-center text-danger'>{this.state.error}</p>}
        {this.state.usernotes.map((note, index) => {
          return (
            <div key={index} className='media mb-2'>
              <img className='mr-2 rounded-circle thumb32' src={'/img/blank_profile.png'} />
              <div className='media-body'>
                <span>
                  <p className='m-0'>
                    <strong>{`${note.created_by?.first_name} ${note.created_by.last_name}`}</strong>
                  </p>
                  <p className='m-0 text-muted'>{note.note}</p>
                </span>
              </div>
              <small className='ml-auto text-muted'>{moment(note.created_date).fromNow()}</small>
              {note.created_by._id == this.props.userStore.user_id && (
                <div className='float-right'>
                  <Dropdown
                    isOpen={this.state.dropdownOpen[index] ? this.state.dropdownOpen[index] : false}
                    toggle={() => {
                      this.dropdownToggle(index)
                    }}
                  >
                    <DropdownToggle className='btn-xs' color='link'>
                      <em className='fa fa-ellipsis-v fa-lg text-muted' />
                    </DropdownToggle>
                    <DropdownMenu className='dropdown-menu-right-forced animated fadeInLeft'>
                      <DropdownItem
                        className='cursor-pointer'
                        onClick={() => {
                          this.deleteNote(note._id)
                        }}
                      >
                        <span>Fshij komentin</span>
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              )}
            </div>
          )
        })}
        <div className='card-body'>
          <form className='mb-2 mt-2' onSubmit={this.saveNote} action=''>
            <input
              type='text'
              value={this.state.newNote}
              onChange={this.onChangeNote}
              className='form-control no-resize'
              placeholder='Shkruaj shënim'
              rows='1'
            />

            <div className='clearfix' style={{ marginTop: 10 }}>
              <div className='float-right'>
                <button className='btn btn-info btn-sm' type='submit'>
                  Ruaj
                </button>
              </div>
            </div>
          </form>

          {/* Flex container for Transferet and Historiku */}
          <div style={{ display: 'flex', gap: '20px', marginTop: '30px', flexWrap: 'wrap' }}>
            {/* Transferet Section */}
            {this.props.transfers && this.props.transfers?.[0]?.from_department?.length > 0 ? (
              <div style={{ flex: '1 1 45%', minWidth: '400px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px', gap: '10px' }}>
                  <em className='fa fa-exchange' style={{ fontSize: '18px', color: '#495057' }} />
                  <h4 style={{ margin: 0, fontSize: '18px', fontWeight: '600', color: '#212529' }}>Transferet</h4>
                </div>
                <div style={{ position: 'relative', paddingLeft: '30px' }}>
                  {/* Timeline line */}
                  <div
                    style={{
                      position: 'absolute',
                      left: '8px',
                      top: '10px',
                      bottom: '10px',
                      width: '2px',
                      backgroundColor: '#dee2e6'
                    }}
                  />
                  {this.props.transfers.sort((a, b) => new Date(b.start_date) - new Date(a.start_date)).map((oneTransfer, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          position: 'relative',
                          marginBottom: index === this.props.transfers.length - 1 ? '0' : '16px'
                        }}
                      >
                        {/* Timeline dot */}
                        <div
                          style={{
                            position: 'absolute',
                            left: '-26px',
                            top: '12px',
                            width: '12px',
                            height: '12px',
                            borderRadius: '50%',
                            backgroundColor: '#7b68ee',
                            border: '3px solid #f8f9fa',
                            boxShadow: '0 0 0 2px #7b68ee'
                          }}
                        />
                        {/* Card */}
                        <div
                          style={{
                            backgroundColor: '#ffffff',
                            borderLeft: '4px solid #7b68ee',
                            borderRadius: '8px',
                            padding: '18px 20px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
                            transition: 'all 0.2s ease',
                            cursor: 'default'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.12)'
                            e.currentTarget.style.transform = 'translateX(2px)'
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.08)'
                            e.currentTarget.style.transform = 'translateX(0)'
                          }}
                        >
                          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {/* From Department */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
                              <p style={{ margin: 0, fontSize: '14px', color: '#212529', fontWeight: '500' }}>
                                {oneTransfer.from_department.length
                                  ? oneTransfer.from_department?.map((oneDep, i) => {
                                    return `${oneDep.name}${oneTransfer.from_department.length === 1 || i === oneTransfer.from_department.length - 1 ? '' : ', '
                                      }`
                                  })
                                  : oneTransfer.from_department.name}

                              </p>
                              <em className='fa fa-arrow-circle-right' style={{ fontSize: '14px', color: '#7b68ee' }} />
                              <p style={{ margin: 0, fontSize: '14px', color: '#212529', fontWeight: '500' }}>
                                {oneTransfer?.to_department?.length
                                  ? oneTransfer?.to_department?.map((oneDep, i) => {
                                    return `${oneDep.name}${oneTransfer.to_department.length === 1 || i === oneTransfer.to_department.length - 1 ? '' : ', '
                                      }`
                                  })
                                  : oneTransfer?.to_department?.name}
                              </p>
                            </div>


                            {/* Date */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px', flexWrap: 'wrap' }}>
                              <p style={{ margin: 0, fontSize: '14px', color: '#212529', fontWeight: '500' }}>
                                <em className='fa fa-calendar' style={{ fontSize: '14px', color: '#7b68ee', marginRight: '6px' }} />
                                {moment(oneTransfer?.start_date).format('DD/MM/YYYY')}
                              </p>
                              <p style={{ margin: 0, fontSize: '14px', color: '#212529', fontWeight: '500' }}>
                                <em className='fa fa-user' style={{ fontSize: '14px', color: '#7b68ee', marginRight: '6px' }} />
                                {oneTransfer.changed_by?.first_name} {oneTransfer.changed_by?.last_name}
                              </p>
                              {oneTransfer.transfer_request && (
                                <p style={{ margin: 0, fontSize: '14px', color: '#212529', fontWeight: '500' }}>
                                  <em className='fa fa-tag' style={{ fontSize: '14px', color: '#7b68ee', marginRight: '6px' }} />
                                  {oneTransfer.transfer_request}
                                </p>
                              )}
                            </div>

                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
                {/* Cancel button outside the timeline */}
                {/* {(() => {
                const token = localStorage.getItem('token')
                const decodedToken = token ? jwtDecode(token) : null
                const userPermissions = decodedToken?.permissions_keys || []
                const hasPayrollAccess = userPermissions.includes('payroll_access')

                return (
                  [1, 5, 6].includes(userStore?.userLevel) &&
                  !hasPayrollAccess && (
                    <div style={{ marginTop: '20px', textAlign: 'center' }}>
                      <button
                        onClick={() => {
                          this.handleClickOpen()
                        }}
                        className='btn btn-danger btn-outline'
                        type=''
                        style={{
                          padding: '10px 24px',
                          fontSize: '14px',
                          fontWeight: '500',
                          borderRadius: '6px'
                        }}
                      >
                        <em className='fa fa-times-circle' style={{ marginRight: '8px' }} />
                        Anulo transferin e fundit
                      </button>
                    </div>
                  )
                )
              })()} */}
              </div>
            ) : null}

            {/* Historiku i përdoruesit Section */}
            {this.props.activeStatusChanges && this.props.activeStatusChanges?.length > 0 && (
              <div style={{ flex: '1 1 45%', minWidth: '400px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px', gap: '10px' }}>
                  <h4 style={{ margin: 0, fontSize: '18px', fontWeight: '600', color: '#212529' }}>Historiku</h4>
                </div>
                <div style={{ position: 'relative', paddingLeft: '30px' }}>
                  {/* Timeline line */}
                  <div
                    style={{
                      position: 'absolute',
                      left: '8px',
                      top: '10px',
                      bottom: '10px',
                      width: '2px',
                      backgroundColor: '#dee2e6'
                    }}
                  />
                  {this.props.activeStatusChanges
                    .slice()
                    .sort((a, b) => new Date(b.changed_date) - new Date(a.changed_date))
                    .map((statusChange, index) => {
                      let actionText = ''
                      let actionColor = ''
                      let actionIcon = ''
                      let actionBgColor = ''

                      // Check if this is the very first status (from_status is null)
                      if (statusChange.from_status === null && statusChange.to_status === true) {
                        actionText = 'Ardhje'
                        actionColor = '#1e90ff'
                        actionIcon = 'fa-user-plus'
                        actionBgColor = '#e3f2fd'
                      } else if (statusChange.from_status === true && statusChange.to_status === false) {
                        actionText = 'Shkëputje'
                        actionColor = '#f85032'
                        actionIcon = 'fa-times-circle'
                        actionBgColor = '#ffebee'
                      } else if (statusChange.from_status === false && statusChange.to_status === true) {
                        actionText = 'Rikthim'
                        actionColor = '#32cd32'
                        actionIcon = 'fa-undo'
                        actionBgColor = '#e8f5e9'
                      }
                      return (
                        <div
                          key={index}
                          style={{
                            position: 'relative',
                            marginBottom: index === this.props.activeStatusChanges.length - 1 ? '0' : '16px'
                          }}
                        >
                          {/* Timeline dot */}
                          <div
                            style={{
                              position: 'absolute',
                              left: '-26px',
                              top: '12px',
                              width: '12px',
                              height: '12px',
                              borderRadius: '50%',
                              backgroundColor: actionColor,
                              border: '3px solid #f8f9fa',
                              boxShadow: '0 0 0 2px ' + actionColor
                            }}
                          />
                          {/* Card */}
                          <div
                            style={{
                              backgroundColor: '#ffffff',
                              borderLeft: `4px solid ${actionColor}`,
                              borderRadius: '8px',
                              padding: '16px 18px',
                              boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
                              transition: 'all 0.2s ease',
                              cursor: 'default'
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.12)'
                              e.currentTarget.style.transform = 'translateX(2px)'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.08)'
                              e.currentTarget.style.transform = 'translateX(0)'
                            }}
                          >
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div
                                  style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '8px',
                                    backgroundColor: actionBgColor,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: 0
                                  }}
                                >
                                  <em className={`fa ${actionIcon}`} style={{ fontSize: '18px', color: actionColor }} />
                                </div>
                                <div>

                                  <div style={{ display: 'flex', flexDirection: 'column', }}>
                                    {/* From Department */}
                                    <p style={{ margin: 0, fontSize: '14px', color: '#212529', fontWeight: '500' }}>
                                      {actionText}
                                    </p>


                                    {/* Date */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
                                      <p style={{ margin: 0, fontSize: '14px', color: '#212529', fontWeight: '500' }}>
                                        <em className='fa fa-calendar' style={{ fontSize: '14px', color: actionColor, marginRight: '6px' }} />
                                        {moment(statusChange.changed_date).format('DD/MM/YYYY')}
                                      </p>
                                    </div>

                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default UserNotes
